import React from 'react';
import { Link } from 'react-router-dom';
import { getDomain } from '../utils/getDomain';
import { getHostname } from '../utils/getHostname';

function Footer() {
  const domain = getDomain();
  const contactEmail = `contact@${domain}`;
  const hostname = getHostname();
  
  return (
    <footer>
      <div className="container">
        <div className="widget-footer">
          <h4>Links</h4>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/tos">Terms of Service</a></li>
          </ul>
        </div>
        <div className="widget-footer empty-widget">
          <h4></h4>
        </div>
        <div className="widget-footer empty-widget">
          <h4></h4>
          <ul>
          </ul>
        </div>
        <div className="widget-footer">
          <h4>Contact Us</h4>
          <ul>
            <li><a href={`mailto:${contactEmail}`}>{contactEmail}</a></li>
          </ul>
        </div>
        <div className="widget-footer last">
          <Link to="/"><img src="/images/logo.svg" alt="logo" style={{ height: '48px', width: '48px' }} /></Link>
          <p className="footer-tagline">Private. Anonymous. Incognito.</p>
        </div>
        <div className="copyright">
          <p>&copy; Copyright {new Date().getFullYear()} {hostname}, All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
